import { css, jsx } from '@emotion/core';
import PropTypes from 'prop-types';
import React from 'react';

import { colors } from '@/styles';

const style = {
  asterisk: css`
    line-height: 1;
    font-size: 15px;
    color: ${colors.primaryBlue};
    font-family: SimSun, sans-serif;
    font-weight: bold;
    padding-right: 4px;
  `,
  text: css`
    font-size: 1.6rem;
  `,
  wrapper: css`
    display: flex;
    align-items: baseline;
  `,
};

const RequiredFields = ({ isPlural }) => {
  return (
    <span css={style.wrapper}>
      <span css={style.asterisk}>*</span>
      <p css={style.text}>Required Field{isPlural && 's'}</p>
    </span>
  );
};

RequiredFields.propTypes = {
  isPlural: PropTypes.bool,
};

RequiredFields.defaultProps = {
  isPlural: true,
};

export default RequiredFields;
